import { ExclamationTriangleFill } from "@styled-icons/bootstrap";
import { ChangeEvent } from "react";
import Form from "react-bootstrap/Form";
import styled from "styled-components";

interface TextAreaProps {
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
  hasError?: boolean;
  classNames?: string;
  errorMessage?: string;
}

export const TextArea = (props: TextAreaProps) => {
  const {
    placeholder = "",
    value,
    onChange,
    hasError = false,
    errorMessage,
    classNames = "",
  } = props;

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  return (
    <TextAreaBoxStyled hasError={hasError}>
      <Form.Control
        placeholder={placeholder}
        type="text"
        as="textarea"
        value={value}
        onChange={handleChange}
        className={`animate__animated ${classNames}`}
      />

      {hasError ? (
        <ErrorMessageStyled>
          <ExclamationTriangleFill size={18} />

          <span>{errorMessage}</span>
        </ErrorMessageStyled>
      ) : null}
    </TextAreaBoxStyled>
  );
};

export const ErrorMessageStyled = styled("div")`
  color: var(--widget-danger);
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0.5rem 0;
`;

const TextAreaBoxStyled = styled("div")<{ hasError: boolean }>`
  textarea {
    resize: none;
    height: auto;
    color: ${(props) => (props.hasError ? "var(--widget-danger)" : "inherit")};

    border-color: ${(props) => (props.hasError ? "var(--widget-danger)" : "inherit")};
  }
`;
